import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consolide-ticket-caisse',
  templateUrl: './consolide-ticket-caisse.component.html',
  styleUrls: ['./consolide-ticket-caisse.component.scss']
})
export class ConsolideTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
